import { teamData } from "./teamData";
import linkedIn from "../../assets/images/Team/linkedin.png";
import telegram from "../../assets/images/Team/telegram.svg";
import React from "react";

export default function Team() {
  return (
    <section className="team-wrapper" id="команда">
      <h2>Команда</h2>
      <div className="team-items-wrapper">
        { teamData.map(item =>
          <div className="team-item" key={ item.name }>
            <div className="img-wrapper">
              <img src={ item.photo } alt={ item.name }/>
              <div className="connect-wrapper">
                <a href={ item.telegram } target="_blank" rel="noreferrer">
                  <img src={ telegram } alt="telegram" />
                </a>
                <a href={ item.link } target="_blank" rel="noreferrer">
                  <img src={ linkedIn } alt="LinkedIn" />
                </a>
              </div>
            </div>
            <p className="team-item-name">{ item.name }</p>
            <p className="team-item-description">{ item.description }</p>
          </div>
        ) }
      </div>
    </section>
  );
}
